import {ContainerSVG} from "components/waste-icons/svgs/ContainerSVG";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const AssetBasic = ({asset}) => {
    const [tc] = useTranslation("choices")
    return (
        <div className="row card-asset-basic">
            <div className="col asset-svg">
                <ContainerSVG type={asset.waste_type}/>
                <div className="row overflow-x-hidden">
                    <small className="text-muted fs-08">{tc("wastes." + asset.waste_type)}</small>
                </div>
            </div>
            <div className="col">
                {asset.model_name ? <div className="small fw-semibold">{asset.model_name}</div> : <></>}
                <small className="text-muted" title="UID">{asset.uid}</small>
                {asset.uuids ? <div className="small text-muted" title="UUID">{asset.uuids}</div> : <></>}
                {asset.uuid ? <div className="small text-muted" title="UUID">{asset.uuid}</div> : <></>}
                <div>{asset.full_address}</div>
            </div>
            <div className="col icons">
                {
                    asset.has_device
                        ? <FontAwesomeIcon icon="wifi" title="Tiene sensor"/>
                        : <></>
                }
                {
                    asset.has_route
                        ? <FontAwesomeIcon icon="truck-fast" title="Tiene Ruta"/>
                        : <></>
                }
            </div>
        </div>
    )
}
export default AssetBasic